import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { MatDialog } from '@angular/material/dialog';
import { environment } from 'apps/mba-cpr-survey-portal/src/environments/environment';
import { TableApiService } from '@suvo/frontend/SUVO-BI-CLIENT-LIB/projects/suvo-bi-client-lib/src/lib/features/tables/services/table-api.service';
import { ConfirmDialogComponent } from '../../../../shared/components/confirm-dialog/confirm-dialog.component';
import { ICpr } from '../interface/cpr.interface';

@Injectable()
export class CprsService extends TableApiService<ICpr> {
  constructor(
    private readonly dialog: MatDialog,
    http: HttpClient,
  ) {
    super(http, `${environment.cprServiceApi}cpr/`);
  }

  delete(cprId: string, onSuccess?: () => void) {
    this.dialog.open(ConfirmDialogComponent, {
      data: {
        onConfirm: async () => {
          await this.deleteOne('', cprId);
          onSuccess?.();
        },
        title: 'Delete CPR',
        body: 'Are you sure you want to delete the CPR?',
        confirmButtonLabel: 'Delete CPR',
      },
    });
  }
}
